export const MoveType = {
  Entry: 0,
  Exit: 1,
};
